import React from "react";
import PersonalSchedulePage from "pages/PersonalSchedulePage/PersonalSchedulePage";

const PersonalScheduleService: React.FC = () => {
  return <PersonalSchedulePage />;
};

export default PersonalScheduleService;
